<template>
    <div><!-- 招標案件明細 -->
        <CCard class="w-100">
            <CCardHeader class="header_group">
                <strong>{{$t('QuoteInfo_Vue.DetailInfo')}}</strong>
                <router-link class="btn btn-dark" to="" v-on:click.native.prevent="goBack">{{$t('Buttons.GoBack')}}</router-link>
            </CCardHeader>
            <CCardBody>
                <CNavbar light color="light">
                    <CForm>
                        <div class="CForminline">
                            <div class="factory">
                                <p>{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <p>{{factoryMap[quoteRow.factoryId] + '('+ quoteRow.factoryId+')'}}</p>
                            </div>
                            <div class="date">
                                <p>{{$t('QuoteInfo_Vue.StartDate')}}： {{quoteRow.startDate}} </p>
                            </div>
                            <div class="quotation_name">
                                <p>{{$t('QuoteInfo_Vue.RequestName')}}：</p>
                                <p>{{quoteRow.requestName}}</p>
                            </div>
                            <div class="factory_id">
                                <p>{{$t('QuoteInfo_Vue.QuoteNo')}}： {{quoteRow.quoteNo}} </p>
                            </div>                            
                            <div class="quotation_class">
                                <p>{{$t('QuoteInfo_Vue.RequestType')}}：</p>
                                <p>{{requestTypeMap[quoteRow.requestType]}}</p>
                            </div>
                            <div class="purchase_info">
                                <p>{{$t('QuoteInfo_Vue.Deadline')}}：</p>
                                <p>{{quoteRow.deadline}}</p> 
                            </div>
                            <div class="purchase_person">
                                <p>{{$t('QuoteInfo_Vue.Purchaser')}}：</p>
                                <p>{{quoteRow.purchaserName}}</p>
                            </div>
                            <table class="table">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center">幣別</th>
                                        <th class="text-center">未稅總價</th>
                                        <th class="text-center">備註說明</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center">{{quoteVendorRow.currency}}</td>
                                        <td class="text-center">{{quoteVendorRow.totalPriceWithoutTax | currency}}</td>
                                        <td class="text-center">                                            
                                            <input type="text" :disabled="isView" style="width:500px;" v-model="quoteVendorRow.memo">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>                            
                        </div>
                    </CForm>
                </CNavbar>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
export default {
    data() {
        return {         
            factoryList: this.$t('factoryListForPurchase'), //廠別 清單
            requestTypeList: this.$t('requestTypeList'), //報價類別 清單   
        }
    },
    props : {
        quoteRow : Object ,
        quoteVendorRow: Object ,
        isView : Boolean
    },
    methods: {
        goBack (){                        
            const self =this;
            if(self.isView){
                self.actionGoBack ();
                return;
            }
            this.$confirm('尚未儲存變更的資料，您確定要離開目前的網頁嗎？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
            }).then(() => {
                self.actionGoBack ();
            }).catch(() => {
                //console.log("放棄了");
            });
        },
        actionGoBack (){    
            this.$router.push('/Manufacturer');
        }
    },
    computed: {
        factoryMap (){
            return this.listToMap(this.factoryList, 'factoryId' ,'factoryCaption');
        },
        requestTypeMap (){
            return this.listToMap(this.requestTypeList, 'requestTypeId' ,'requestTypeCaption');
        }
    },
    mounted() {        
    }
}	
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .factory, .date, .quotation_name, .factory_id, .quotation_class, .quotation_method, .audit, .purchase_info, .purchase_person {
        display: flex;
        align-items: center;
        margin: .5rem 0;

        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
    }
    table th:first-child {
        text-align: center;
        padding: 15px 5px;
    }
}
.header_group {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
</style>
